module.exports = __webpack_public_path__ + "img/people-gathered-inside-house-sitting-on-sofa-1054974.396eebfb.jpg";